import React from 'react';

const ReadingPassage = () => {
    return (
        <div className="flex flex-col w-full lg:w-[35%] bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden h-[75vh]">
            <div className="bg-[#D7EAFF] px-4 py-5">
                <span className="text-sm tracking-tight font-[500] text-gray-700">Reading Passage</span>
            </div>
            <div className="p-5 overflow-y-auto custom-scrollbar text-sm leading-relaxed text-gray-800">
                <div className="mb-2 border-gray-100 font-[500] tracking-tight text-[#333333]">
                    Question 1 of 5
                </div>
                <h4 className="font-[500] text-[14px] tracking-tight mb-3">Question 1: This is a sample question for question number 1. What is the correct answer?</h4>
                <p className="font-[500] text-[14px] tracking-tight mb-3">
                    Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source.
                </p>
                <p className="font-[500] text-[14px] tracking-tight mb-3">
                    Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.
                </p>
            </div>
        </div>
    );
};

export default ReadingPassage; 